module.exports = __webpack_public_path__ + "img/room-creative-award_zhar.2c7e2815.png";